export const channels = [
  {
    slug: 'regua',
    name: '今日热瓜',
    icon: 'ri-fire-line',
    desc: '全网刚出炉的热闹事，三分钟看懂前因后果，吃瓜不迷路。',
    tint: 'accent',
    count: 128,
  },
  {
    slug: 'xiafan',
    name: '下饭专区',
    icon: 'ri-restaurant-2-line',
    desc: '饭点专属配菜，一口饭一口笑，锅气与笑点齐飞。',
    tint: 'primary',
    count: 96,
  },
  {
    slug: 'moyu',
    name: '摸鱼段子',
    icon: 'ri-cup-line',
    desc: '上班间隙的两分钟乐子，看完继续假装认真工作。',
    tint: 'secondary',
    count: 173,
  },
  {
    slug: 'shadiaotujian',
    name: '沙雕图鉴',
    icon: 'ri-image-2-line',
    desc: '一眼笑出声的离谱瞬间，截图比文字更有杀伤力。',
    tint: 'accent',
    count: 84,
  },
  {
    slug: 'mihuo',
    name: '迷惑行为',
    icon: 'ri-question-line',
    desc: '看不懂但大受震撼的日常操作，人类观察实录。',
    tint: 'primary',
    count: 61,
  },
  {
    slug: 'yezhu',
    name: '夜市闲谈',
    icon: 'ri-moon-line',
    desc: '深夜才有的碎碎念与冷知识，适合睡前来两条。',
    tint: 'secondary',
    count: 47,
  },
];

export const hotTags = [
  '打工人日常',
  '公司迷惑行为',
  '外卖刺客',
  '宿舍名场面',
  '年会名场面',
  '健身失败',
  '地铁奇遇',
  '猫奴现状',
  '食堂阿姨手抖',
  '熬夜追剧',
];